<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Field Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`New ${customer.full_name} Field`" class="mb-3">
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Customer Field Actions">
          <b-button
            :to="`/customer/${customer_id}`"
            variant="success"
            class="ml-1 text-white"
          >
            <i class="fal fa-arrow-left" />
          </b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'add customer field'">
      <template #gated-content>
        <customer-field-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import CustomerFieldForm from '@/components/crm/customerfield/form/CustomerFieldForm.vue'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate.vue'
import BasicHeading from '@/components/shared/BasicHeading.vue'
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import { CrmRepositoryFactory } from '@/repositories/crm/CrmRepositoryFactory'
import { getModel } from '@/shared/fetch-utils'
import { customerFieldNotifications } from '@/shared/notifications'
import { notificationOptions } from '@/shared/toast-notification-options'
import Vue from 'vue'
import VueNotifications from 'vue-notifications'

const CustomerFieldsRepository = CrmRepositoryFactory.get('customerFields')

Vue.use(VueNotifications, notificationOptions)

export default {
  name: "CustomerFieldAdd",
  mixins: [ToastNotifications],
  components: {
    BasicHeading,
    CustomerFieldForm,
    PermissionAlertGate,
  },
  data () {
    return {
      loading: true,
      customer_id: this.$route.params.customer_id,
      customer: null,
    };
  },
  async created () {
    this.loading = true

    this.customer = await getModel({
      model_type: "customer",
      id: this.customer_id,
      message: this.$bvToast,
    });

    this.loading = false
  },
  methods: {
    async submit (form_data) {
      try {
        for (const field of form_data) {
          await CustomerFieldsRepository.create({
            customer_id: this.customer_id,
            ...field,
          })
        }

        this.addSuccess()
        this.$router.push(`/customer/${this.customer_id}`)
      } catch ({ response }) {
        const { status, data } = response

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: 'Server Error.',
          variant: 'danger',
        })
      }
    }
  },
  notifications: customerFieldNotifications,
}
</script>
